import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Header, Form, Divider } from 'semantic-ui-react';
import { string, oneOfType, object, bool } from 'prop-types';

import { Routes } from '../routing';
import { Wrappers } from '../components';

const ErrorCard = ({ title, description, qa, showLink = true, alignLeft = false }) => (
  <Wrappers.SegmentFull theme="center">
    <Header data-qa={qa} as="h1">
      {title}
    </Header>
    {alignLeft && description && <p align="left">{description}</p>}
    {!alignLeft && description && <p>{description}</p>}
    <Divider hidden />
    {showLink && (
      <Form.Field className="field--center">
        <a href={Routes.home} className="link--boxed">
          <FormattedMessage
            id="cta.home"
            description="Home link label"
            defaultMessage="AGI Dealer Support Home"
          />
        </a>
      </Form.Field>
    )}
  </Wrappers.SegmentFull>
);

ErrorCard.propTypes = {
  title: oneOfType([object, string]).isRequired,
  description: oneOfType([object, string]),
  showLink: bool,
  alignLeft: bool,
  qa: string
};

export default ErrorCard;



// WEBPACK FOOTER //
// ./src/components/ErrorCard.js